import styled from 'styled-components';


export const ReportWrapper = styled.div`
    width: 100%;
    height: 80vh;

    .ag-header {
        background-color: #133366;
        color: white;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        font-family: Roboto;
    }

    .ag-header-cell::after {
        //border-right: 1px solid #ccc;
        content: " ";
        height: 16px;
        margin-top: 4px;
        position: absolute;
        text-indent: -2000px;
        top: 0;
        right: 0;
    }

    .ag-body-viewport {
        border-left: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
    }

    .ag-floating-top {
        overflow: hidden !important;
    }

    .ag-row {
        z-index: 0;
    }

        .ag-row.ag-row-hover {
        background-color: #eaf2fa;
    }

    .ag-row.ag-row-focus {
        z-index: 1;
    }

    .ag-row.ag-row-selected {
        background-color: inherit;
    }

    .ag-header-group-cell-label {
        justify-content: center;
    }

    .list-header {
        //background-color: #F6CC9F;
        color: #fff;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        border-color: #eee;
        border-width: 1px 1px 0px 0px;
        border-style: solid;
        font-weight: 500;
        padding-bottom: 5px;
    }

    .list-header-right {
        //background-color: #F6CC9F;
        color: #fff;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        border-color: #eee;
        border-width: 1px 1px 0px 0px;
        border-style: solid;
        font-weight: 500;
        padding-bottom: 5px;
    }

    .list-cell-center {
        border-bottom: none;
        text-align: center;
        line-height: 28px;
        border-color: #eee;
    }

    .list-cell-center .ag-cell-wrapper {
        justify-content: center;
    }

    .list-cell-center .ag-selection-checkbox {
        margin: 0;
    }

    .list-header .ag-header-cell-label {
        justify-content: center;
    }

    .list-header .ag-header-select-all {
        margin: 0 auto;
    }

    .list-header-checkbox {
        padding-bottom: 9px !important;
    }

    .list-header .ag-header-select-all {
        filter: brightness(0) invert(1);
    }


    .list-cell-right {
        //background-color: #F6CC9F;
        //color: black;
        border-bottom: none;
        text-align: right;
        line-height: 28px;
        border-color: #eee;
    }
    
    .list-header > .ag-cell-label-container > .ag-header-cell-label {
        display: flex;
        justify-content: center;
    }

    .ag-header-row > .ag-header-group-cell > .ag-header-group-cell-label {
        display: flex;
        justify-content: center;
    }

    .totals {
        font-weight: 600;
        background-color: #ddd;
    }

    .react-grid-Row:hover .react-grid-Cell, .react-grid-Row.row-context-menu .react-grid-Cell {
        background-color: lightgoldenrodyellow;
    }

    .ag-icon.ag-icon-asc {
        color: white;
    }

    .ag-icon.ag-icon-desc {
        color: white;
    }

    .ag-icon.ag-icon-expanded {
        color: white;
    }

    .ag-icon.ag-icon-contracted {
        color: white;
    }

    .customHeaderLabel {
        margin-left: 5px;
        float: left;
        text-align: center;
    }

    .customSortDownLabel {
        // float: left;
        margin-left: 3px;
    }

    .customSortUpLabel {
        // float: left;
        margin-left: 3px;
    }

    .customSortRemoveLabel {
        float: left;
        font-size: 11px;
        margin-left: 3px;
    }

    .active {
        color: cornflowerblue;
    }
`

export const DetailReportWrapper = styled.div`
    width: 100%;

    .ag-header {
        background-color: #133366;
        color: white;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        font-family: Roboto;
    }

    .ag-header-cell::after {
        //border-right: 1px solid #ccc;
        content: " ";
        height: 16px;
        margin-top: 4px;
        position: absolute;
        text-indent: -2000px;
        top: 0;
        right: 0;
    }

    .ag-body-viewport {
        border-left: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
        overflow-x: hidden;
    }

    .ag-floating-top {
        overflow: hidden !important;
    }

    .ag-row {
        z-index: 0;
    }

        .ag-row.ag-row-hover {
        background-color: #eaf2fa;
    }

    .ag-row.ag-row-focus {
        z-index: 1;
    }

    .ag-header-group-cell-label {
        justify-content: center;
    }

    .list-header {
        //background-color: #F6CC9F;
        color: #fff;
        display: flex;
        justify-content: center;
        // align-items: flex-end;
        border-color: #eee;
        border-width: 1px 1px 0px 0px;
        border-style: solid;
        font-weight: 500;
        font-size: 12px;
        // padding-bottom: 5px;
        padding-top: 2px;
    }

    .list-cell {
        border-bottom: none;
        text-align: center;
        line-height: 28px;
        border-color: #eee;
        font-size: 12px;
    }
    
    .list-header > .ag-cell-label-container > .ag-header-cell-label {
        display: flex;
        justify-content: center;
    }

    .ag-header-row > .ag-header-group-cell > .ag-header-group-cell-label {
        display: flex;
        justify-content: center;
    }

    .totals {
        font-weight: 600;
        background-color: #ddd;
    }

    .react-grid-Row:hover .react-grid-Cell, .react-grid-Row.row-context-menu .react-grid-Cell {
        background-color: lightgoldenrodyellow;
    }

    .ag-icon.ag-icon-asc {
        color: white;
    }

    .ag-icon.ag-icon-desc {
        color: white;
    }

    .ag-icon.ag-icon-expanded {
        color: white;
    }

    .ag-icon.ag-icon-contracted {
        color: white;
    }

    .customHeaderLabel {
        margin-left: 5px;
        float: left;
        text-align: center;
    }

    .customSortDownLabel {
        // float: left;
        margin-left: 3px;
    }

    .customSortUpLabel {
        // float: left;
        margin-left: 3px;
    }

    .customSortRemoveLabel {
        float: left;
        font-size: 11px;
        margin-left: 3px;
    }

    .active {
        color: cornflowerblue;
    }
`

    ;